import type { Locale } from "@/lib/i18n";
import { pl, type WLatestNewsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wLatestNewsTranslations: Record<Locale, WLatestNewsTranslations> = {
  pl,
  en,
  de,
};

export type { WLatestNewsTranslations };
